const selectors = {
  getProjectCacheLogs: (state, projectId, page, resultsPerPage) =>
    state.projects.getIn(['cacheLogs', projectId, page, resultsPerPage]),
  getProjectsCacheLogs: (state, district) =>
    state.projects.getIn(['allCacheLogs', district])
};

export default selectors;
